const TABLE_CELL_SEPARATOR = '|';

export function isTableLine(line: string): boolean {
    return line.startsWith(TABLE_CELL_SEPARATOR);
}

export function parseTable(lines: string[]): any {
    const rows = lines.map(parseTableRow);
    return { type: 'table', rows };
}

function parseTableRow(line: string): string[] {
    return line.split(TABLE_CELL_SEPARATOR).slice(1, -1);
}
